export const appType = 'main'; // 'club';
export const clubId = null; //31051008; //28101480; //310510386;
export const organizerId = null; //116;
export const appClient = null; //'rsgc'; //'WAGC';
export const membersOnly = false;
export const DEFAULT_REDIRECT = 'tabs/player-home'; // 'tabs/rsgc-player-home';

// export const appType = 'club'; // 'club';
// export const clubId = 310510386; //310510386;

export const MygolfServerHost = 'miglet.mygolf2u.com';
// export const MygolfServerHost = 'clslet.mygolf2u.com';
export const MygolfUIServerHost = 'mig-newplay.mygolf2u.com';
export const MygolfSSLEnable = true;

export const devMode = true;
export const toggleDevMode = true;
export const environment = 'dev';
export const appEnvironment = 'mig';
export const enableChat = false;
export const chatServer = 'migchat.mygolf2u.com';
export const chatPort = '11015';

export const filterNewsPromoByDates = false;

export const enableStayNPlayRequest = true;

export const majorAppVersion = '5.0.0';

// Live Update Configuration
export const updateConfig = {
  enabled: false, // DISABLED: CapacitorUpdater has fundamental Android compatibility issues
  autoCheck: true,
  checkInterval: 3600000, // 1 hour in milliseconds
  autoDownload: true,
  mandatoryUpdateDelay: 300000, // 5 minutes in milliseconds
  useStaticServer: false, // Use static server without token auth (for testing)
  updateServerUrl: 'https://migupdates.mygolf2u.com',
  tokenEndpoint: 'https://migupdates.mygolf2u.com/api/updates/token',
  publicKey: '',
};

export const MygolfPortal = 'mig-port.mygolf2u.com';
